import React from "react";
import assign from "lodash/assign";
import { RaisedButton } from "material-ui";
import { Navigation, Link } from "react-router";

import BaseOverlay from "./base.jsx";
import Checkout from "../partials/checkout.jsx";
import InjectedTenantHTML from "../partials/injected-tenant-html.jsx";

import statics from "alt-utils/lib/statics";
import connectToStores from "alt-utils/lib/connectToStores";
import OrderStore from "../../stores/OrderStore";
import PersonStore from "../../stores/PersonStore";
import OrderActions from "../../actions/OrderActions";
import PassStore from "../../stores/PassStore";

export default statics(
  {
    willTransitionTo({ location }, replace, callback) {
      OrderActions.newOrderFlow();
      OrderActions.updateCurrentOrder({
        subitems: [
          {
            credits: +location.query.credits,
            with_discount: location.state && location.state.withDiscount
          }
        ]
      });
      callback();
    }
  },

  @connectToStores
  class BuyCreditsOverlay extends React.Component {
    constructor(props) {
      super(props);
      this.cancel = this.cancel.bind(this);
    }

    static getStores() {
      return [OrderStore, PersonStore, PassStore];
    }

    static get contextTypes() {
      return {
        router: React.PropTypes.object.isRequired,
        appSettings: React.PropTypes.object.isRequired,
        tenant: React.PropTypes.object.isRequired
      };
    }

    static getPropsFromStores() {
      var state = OrderStore.getState();
      state.getOrderById = OrderStore.getOrderById;
      state.isLoggedIn = PersonStore.getState().isLoggedIn;
      state.person = PersonStore.getState().details;
      state.hasPassesOfBucket = PassStore.hasPassesOfBucket;
      state.hasUpdatedAllPasses = PassStore.getState().hasUpdatedAll;
      return state;
    }

    cancel() {
      if (!(this.props.orderInProgress || this.props.orderSuccess)) {
        if (
          this.props.location.state &&
          this.props.location.state.fromMainListing
        ) {
          this.context.router.goBack();
        } else {
          this.context.router.push(`/credits`);
        }
      }
    }

    submit() {
      OrderActions.submitOrder.defer();
    }

    render() {
      const showNotAllowed =
        this.context.appSettings.credits_allowed_pass_buckets.length > 0 &&
        (!this.props.isLoggedIn ||
          !this.context.appSettings.credits_allowed_pass_buckets.some(b =>
            this.props.hasPassesOfBucket(b)
          ));

      return (
        <BaseOverlay onRequestClose={this.cancel}>
          {showNotAllowed ? (
            <div style={{ padding: 20, textAlign: "center" }}>
              <InjectedTenantHTML
                content={this.context.tenant.credits_not_allowed}
              />
              <div style={{ marginTop: 10 }}>
                <RaisedButton
                  label={
                    this.context.tenant.credits_not_allowed_pass_button_text
                  }
                  primary={true}
                  onClick={() =>
                    this.context.router.push(
                      `/${this.context.tenant.passes_url_pathname}/buy`
                    )
                  }
                />
                {!this.props.isLoggedIn ? (
                  <div style={{ marginTop: 10 }}>
                    Or <Link to="/login?next=back">login to your account</Link>
                  </div>
                ) : null}
              </div>
            </div>
          ) : (
            <Checkout
              orderInProgress={this.props.orderInProgress}
              orderSuccess={this.props.orderSuccess}
              orderErrorMessage={this.props.orderErrorMessage}
              orderData={this.props.orderData}
              updateCurrentOrder={OrderActions.updateCurrentOrder}
              completedOrder={this.props.getOrderById(
                this.props.completedOrderId
              )}
              person={this.props.person}
              isLoggedIn={this.props.isLoggedIn}
              item={{
                name: `Credits – ${this.props.location.query.credits} Pack`,
                credits: true
              }}
              hideQuantity={true}
              forceShowPaymentSummary={true}
              buyLabel={"Top-up"}
              actionVerb={"top-up"}
              cancel={this.cancel}
              submit={this.submit}
            />
          )}
        </BaseOverlay>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/app/components/overlays/buy-credits.jsx